// getters.js

export default {
    getRemoteConfigs(state){
        return state.remoteConfigs
    },
    getRemoteConfigById: (state) => (id) => {
        let result = {
            isExist: false,
            config_data: null
        }
        let config = state.remoteConfigs.find(config=>config.device_id === id)
        if(config){
            result.isExist = true
            result.config_data = config.config_data
        }
        return result
    }
};
